import { render, staticRenderFns } from "./VInputFiles.vue?vue&type=template&id=135ec1f2&"
import script from "./VInputFiles.vue?vue&type=script&lang=js&"
export * from "./VInputFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports